import { Spacing, Media, StackChildren, Text } from '@doordash/design-language'
import * as React from 'react'
import styled from 'styled-components'

import t from './strings'

export const Container = styled(StackChildren)`
  line-height: ${Spacing.Large}px;

  ${Media.Mobile`
    height: 100vh;
    padding-top: ${Spacing.XxLarge}px;
  `}
`

export const JapanNonCitizenGuide = () => (
  <Container>
    <Text styles={Text.Styles.PageDescriptionBody}>{t.explanation1()}</Text>
    <Text styles={Text.Styles.PageDescriptionBody}>{t.explanation2()}</Text>
  </Container>
)

export default JapanNonCitizenGuide
